import { ButtonGroup, Button, Grid2 as Grid, Typography, AppBar, Toolbar } from "@mui/material"
import React, { useEffect } from "react"
import { useLocation, useParams } from "react-router-dom"
import { useEvent } from "../../context/eventContext";
import { get_Event_byID } from "../../FirebaseUtils/dbEvent";
import ElevationScroll from "../ElevationScroll";


const page_list = [
    { id: 'publiccatalog', label: 'Catalogo', link: 'publiccatalog' },
    { id: 'publicmatch', label: 'Gare', link: 'publicmatch' },
]

export const MenuHeader = ({ admin }) => {
    const location = useLocation()
    const { hash, pathname, search } = location
    const { event_id } = useParams()
    const { selEvent, setSelEvent } = useEvent()
    useEffect(() => {
        const initData = async () => {
            console.log("INIT DATA")
            if (event_id) {
                const ev = await get_Event_byID(event_id)
                if (ev) {
                    setSelEvent(ev)
                }
            }
        }
        initData()

    }, [event_id])

    return (
        <>
            <ElevationScroll>
                <AppBar sx={{ backgroundColor: '#fff' }}>
                    <Grid container spacing={2} alignItems={"center"}>
                        <Grid sx={{ textAlign: 'center' }} size={"auto"}>
                            <img src="/logo-ANAFIBJ-600.png" width="40px" />
                            <Typography
                                sx={{ width: '100%', fontSize: '8px', fontWeight: 'bold', color: '#8fb5d7' }}
                                md={{ width: '100%', fontSize: '', fontWeight: 'bold', color: '#8fb5d7' }}
                            >
                                ShowTimeANAFIBJ
                            </Typography>
                        </Grid>
                        <Grid sx={{ textAlign: 'center' }} size={3}>
                            <Button size="small" variant={"outlined"} href="/">Lista eventi</Button>
                        </Grid>
                        <Grid size="grow">
                            {selEvent?.event_name &&
                                <>
                                    <Grid size="grow" sx={{ textAlign: 'center', backgroundColor: 'lightblue', fontWeight: 'bold', fontSize: '1.2em' }}>
                                        {selEvent?.event_name}
                                    </Grid>
                                    <Grid sx={{ textAlign: "center" }}>
                                        <ButtonGroup fullWidth>
                                            {page_list.map((p, k) => (
                                                <Button size="small" variant={pathname.endsWith(p.link) ? 'contained' : 'outlined'} href={p.link} key={k}>{p.label}</Button>
                                            ))}
                                        </ButtonGroup>

                                    </Grid>
                                </>
                            }
                        </Grid>
                    </Grid>
                </AppBar>
            </ElevationScroll>
            <Toolbar />
        </>
    )
}